"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertInitialSelections = void 0;

var _commonUtils = require("./commonUtils");

var convertInitialSelections = function convertInitialSelections(initialSelections, productAttributeKeys, sortedAttributesList, hiddenAttributes) {
  var v2InitialSelections = {};

  var _loop = function _loop(i) {
    var key = initialSelections[i].key;
    var isHidden = !initialSelections[i].isDisplayed;

    if (!(hiddenAttributes && hiddenAttributes.includes(key))) {
      if (productAttributeKeys.find(function (attribute) {
        return (0, _commonUtils.areKeysSame)(attribute, key);
      })) {
        isHidden = false;
      }
    }

    v2InitialSelections[key] = {
      isHidden: isHidden,
      initialSelection: initialSelections[i] ? initialSelections[i].resolvedValue : null
    };
  };

  for (var i = 0; initialSelections && i < initialSelections.length; i++) {
    _loop(i);
  }

  var keysexisted = Object.keys(v2InitialSelections);
  var keysNotePresentedInSelections = productAttributeKeys.filter(function (each) {
    return keysexisted.filter(function (each1) {
      return (0, _commonUtils.areKeysSame)(each1, each);
    }).length <= 0;
  });

  for (var each = 0; keysNotePresentedInSelections && each < keysNotePresentedInSelections.length; each += 1) {
    v2InitialSelections[keysNotePresentedInSelections[each]] = {
      isHidden: false,
      initialSelection: null
    };
  }

  var sortedAttrKeys = sortedAttributesList.map(function (each) {
    return each.attributeKey;
  });
  keysexisted = Object.keys(v2InitialSelections);
  var keysNot = sortedAttrKeys.filter(function (each) {
    return keysexisted.filter(function (each1) {
      return (0, _commonUtils.areKeysSame)(each, each1);
    }).length <= 0;
  });

  for (var _each = 0; keysNot && _each < keysNot.length; _each += 1) {
    v2InitialSelections[keysNot[_each]] = {
      isHidden: true,
      initialSelection: null
    };
  }

  return v2InitialSelections;
};

exports.convertInitialSelections = convertInitialSelections;